import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const DesktopPanel = ({ isOpen, onClose, children, align, panelId, anchorRef }) => {
  const panelRef = useRef(null);
  const [style, setStyle] = useState({});

  // Calculate position from anchor element
  useEffect(() => {
    if (!isOpen || !anchorRef?.current) return;

    const updatePosition = () => {
      const rect = anchorRef.current.getBoundingClientRect();
      const top = rect.bottom + 8;

      if (align === 'right') {
        const right = window.innerWidth - rect.right;
        setStyle({ top, right, left: 'auto' });
      } else {
        const left = rect.left;
        setStyle({ top, left });
      }
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [isOpen, anchorRef, align]);

  // Click outside and Escape handlers
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        const isSegment = e.target.closest('.sf-searchbar__segment');
        if (!isSegment) {
          onClose();
        }
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }, 10);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const panelClasses = [
    'sf-quoter',
    'sf-panel',
    panelId === 'dates' ? 'sf-panel--dates' : '',
  ].filter(Boolean).join(' ');

  const panel = (
    <div
      ref={panelRef}
      className={panelClasses}
      style={{ position: 'fixed', zIndex: 999999, ...style }}
    >
      <div className="sf-panel__content">
        {children}
      </div>
    </div>
  );

  return ReactDOM.createPortal(panel, document.body);
};

export default DesktopPanel;
